// noinspection JSUnusedGlobalSymbols

import * as Dayjs from 'dayjs'
import Helper from './helper.js'

export default class Is
{
	static bool(value, numeric = false)
	{
		return numeric ? !!Helper.string(value).match(/^[01]$/) : typeof value === 'boolean'
	}

	static int(value, zero = true)
	{
		const pattern = /^-?\d+$/

		if(typeof value !== 'string' && typeof value !== 'number' || !Helper.string(value).match(pattern)) return false
		return !zero && Number(value) === 0 ? false : !!Helper.string(value).match(pattern)
	}

	static float(value, zero = true)
	{
		const pattern = /^-?\d+(\.\d+)?$/

		if(typeof value !== 'string' && typeof value !== 'number' || !Helper.string(value).match(pattern)) return false
		return !zero && Number(value) === 0 ? false : !!Helper.string(value).match(pattern)
	}

	static filled(value)
	{
		return ['number', 'string'].includes(typeof value) && !Helper.string(value).match(/^[　\s]*$/)
	}

	static date(value)
	{
		if(typeof value !== 'string') return false
		return !!value.match(/^\d+-\d+-\d+$/) && Dayjs(value).isValid()
	}

	static datetime(value)
	{
		if(typeof value !== 'string') return false
		return !!value.match(/^\d+-\d+-\d+ \d+:\d+:\d+$/) && Dayjs(value).isValid()
	}

	static time(value)
	{
		if(typeof value !== 'string') return false
		return !!value.match(/^\d+:\d+$/) && Dayjs(`2000-01-01 ${value}`).isValid()
	}

	static email(value)
	{
		if(typeof value !== 'string') return false

		//https://developer.mozilla.org/en-US/docs/Web/HTML/Element/Input/email#Validation
		// noinspection RegExpSimplifiable
		return !!value.match(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/)
	}

	static object(value)
	{
		return typeof value === 'object' && value !== null
	}
}
